import React from 'react';

export default function PrivacyPolicy() {
  return (
    <main className="legal-page">
      <div className="legal-inner">
        <h1>プライバシーポリシー</h1>
        <p className="legal-updated">最終更新日：2026年5月11日</p>

        <section>
          <h2>1. はじめに</h2>
          <p>
            FakeScan（以下「本サービス」）は、AIが生成したフェイク画像や人為的に加工された画像を検出する無料のWebサービスです。
            本プライバシーポリシーは、本サービスの利用にあたって取り扱う情報について説明します。
          </p>
        </section>

        <section>
          <h2>2. 収集する情報</h2>
          <h3>アップロード画像</h3>
          <p>
            解析のためにアップロードされた画像は、サーバー上で即時処理されます。
            <strong>画像データはサーバーに一切保存されません。</strong>解析完了後、データは破棄されます。
          </p>
          <p>
            なお、画像に埋め込まれたExif情報（撮影日時・カメラ機種・GPS位置情報等）は解析の一部として読み取られますが、
            これも解析結果の表示のみに使用され、保存はされません。
          </p>

          <h3>アクセスログ</h3>
          <p>
            サーバーは標準的なアクセスログ（IPアドレス・リクエスト日時・ブラウザ情報等）を自動的に記録します。
            これらはサービスの安定運用・不正利用の防止を目的として使用し、第三者への提供は行いません。
          </p>
        </section>

        <section>
          <h2>3. 情報の利用目的</h2>
          <ul>
            <li>アップロードされた画像の解析結果を提供するため</li>
            <li>サービスの品質改善・不具合対応のため</li>
            <li>不正利用の検知・防止のため</li>
            <li>Googleアナリティクスによるサービスの利用状況分析のため</li>
          </ul>
        </section>

        <section>
          <h2>4. 第三者への提供</h2>
          <p>
            収集した情報を、法令に基づく開示が必要な場合を除き、第三者に提供・販売・共有することはありません。
          </p>
        </section>

        <section>
          <h2>5. Googleアナリティクスについて</h2>
          <p>
            本サービスはサービスの向上・改善を目的として、Google LLC提供のGoogleアナリティクス（GA4）を使用しています。
            GoogleアナリティクスはCookieを使用してアクセス情報（ページ閲覧数・滞在時間・使用デバイス等）を収集します。
            収集されたデータはGoogleのプライバシーポリシーに基づいて管理されます。
          </p>
          <p>
            Googleアナリティクスによるデータ収集を無効にするには、
            <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer">Googleアナリティクス オプトアウトアドオン</a>をご利用ください。
          </p>
        </section>

        <section>
          <h2>6. セキュリティ</h2>
          <p>
            アップロードされた画像はHTTPS通信によって暗号化されて送受信されます。
            ただし、インターネット上のいかなる通信も完全な安全性を保証するものではありません。
          </p>
        </section>

        <section>
          <h2>7. Cookieについて</h2>
          <p>
            本サービスは独自のトラッキングCookieは使用しません。ただし、Googleアナリティクスが利用するCookieについては第5条をご参照ください。
          </p>
        </section>

        <section>
          <h2>8. 未成年者について</h2>
          <p>
            本サービスは13歳未満の方の利用を想定していません。
          </p>
        </section>

        <section>
          <h2>9. プライバシーポリシーの変更</h2>
          <p>
            本ポリシーは予告なく変更される場合があります。変更後はこのページに掲載し、最終更新日を更新します。
          </p>
        </section>

        <section>
          <h2>10. お問い合わせ</h2>
          <p>
            本ポリシーに関するお問い合わせは、<a href="/contact">お問い合わせページ</a>よりご連絡ください。
          </p>
        </section>
      </div>
    </main>
  );
}
